import React from 'react';

import {List, ListItem} from '@kit';

import css from './master.module.css';

export type PickListItem = {
	id: string;
	title: string;
	caption?: string;
	icon?: React.ReactNode;
	/** почему пункт нельзя выбрать */
	blocker?: string;
};

type Props = {
	items: PickListItem[];
	selectedId?: string;
	onSelect(id: string): void;
};

export const PickList: React.FC<Props> = ({items, selectedId, onSelect}) => (
	<List className={css.pickList} selectMode="single" selectedItems={selectedId ? [selectedId] : []}>
		{items.map((item) => (
			<ListItem
				key={item.id}
				value={item.id}
				icon={item.icon}
				disabled={!!item.blocker}
				onAction={() => !item.blocker && onSelect(item.id)}
			>
				<span className={css.pickText}>
					<span className={css.pickTitle}>{item.title}</span>
					{item.caption && <span className={css.pickCaption}>{item.caption}</span>}
					{item.blocker && <span className={css.pickBlocker}>{item.blocker}</span>}
				</span>
			</ListItem>
		))}
	</List>
);
